export enum BookingError {
  INVALID_DATE = "INVALID_DATE",
  EXCEEDS_LIMIT = "EXCEEDS_LIMIT",
  ITEMS_MISSING = "ITEMS_MISSING",
  SPACE_BOOKED = "SPACE_BOOKED",
  CONFLICT = "CONFLICT",
}
